import Cookies from 'js-cookie';
import BaseUrl from '../../types/BaseUrl';
import ICampaignID from '../../types/ICampaignID';
import ICampaignInfoContainer from "../../types/ICampaignInfoContainer";

// Class to work with cookie as a campaing UUID container
export default class CampaignInfoCookieContainer implements ICampaignInfoContainer {
  readonly containerName = 'cookie';
  readonly parameterName = 'campaign_uuid';
  private cookieDomain: string;
  private readonly validDays = 30;

  constructor(baseUrl: BaseUrl) {
    this.cookieDomain = `.${baseUrl.getDomain()}`;
  }

  load() {
    const result: ICampaignID = {
      UUID: Cookies.get(this.generateCookieName()),
      container: this.containerName
    };

    return result.UUID ? result : null;
  }

  store (campaignId: ICampaignID) {
    if (!!campaignId && campaignId.container == 'param') {
      const cookieConfig: Cookies.CookieAttributes = { expires: this.validDays, domain: this.cookieDomain };
      Cookies.set(this.generateCookieName(), campaignId.UUID, cookieConfig);

      return true;
    }

    return false;
  }

  private generateCookieName(): string {
    return this.parameterName;
  }
}